import { render, staticRenderFns } from "./database-upload-modal.vue?vue&type=template&id=013b07fc&scoped=true&"
import script from "./database-upload-modal.vue?vue&type=script&lang=ts&"
export * from "./database-upload-modal.vue?vue&type=script&lang=ts&"
import style0 from "./database-upload-modal.vue?vue&type=style&index=0&id=013b07fc&prod&lang=less&scoped=true&"
import style1 from "./database-upload-modal.vue?vue&type=style&index=1&id=013b07fc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013b07fc",
  null
  
)

export default component.exports